var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPdfDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.36377 9.61771V1.96521C1.36377 1.78071 1.43706 1.60376 1.56753 1.47329C1.698 1.34283 1.87494 1.26953 2.05945 1.26953H10.4076L15.2774 6.1393V9.61771",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4076 1.26953V6.1393H15.2774",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.36377 15.8784H2.75513C3.12414 15.8784 3.47804 15.7318 3.73897 15.4709C3.9999 15.21 4.14649 14.8561 4.14649 14.4871C4.14649 14.1181 3.9999 13.7642 3.73897 13.5032C3.47804 13.2423 3.12414 13.0957 2.75513 13.0957H1.36377V17.2698",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9731 13.0957H13.5382V17.2698",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6253 15.5312H13.5382",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32059 17.2698C8.87411 17.2698 9.40496 17.0499 9.79635 16.6585C10.1878 16.2671 10.4076 15.7363 10.4076 15.1827C10.4076 14.6292 10.1878 14.0984 9.79635 13.707C9.40496 13.3156 8.87411 13.0957 8.32059 13.0957H7.10315V17.2698H8.32059Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfDownload);
export default __webpack_public_path__ + "static/media/PDFDownload.af6524a8cdcc1e78662f9e1b5ce75f76.svg";
export { ForwardRef as ReactComponent };